module.exports = __webpack_public_path__ + "static/media/header_contact.5d8edc4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_contact.jpg
// module id = 936
// module chunks = 0